import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { invalidateLocalityCache } from 'src/api/localities'
import { invalidateMaintenanceCache, useAddCustomMaintenance } from 'src/api/maintenance'
import { invalidateScheduledMaintenanceCache } from 'src/api/scheduled-maintenance'
import { ISimpleMainComponent } from 'src/generated-types/simple-maincomponent'
import CreateMaintenanceForm from 'src/screens/customer/services/maintenances/CreateMaintenanceForm'
import { ShowDialogProps } from 'src/show-dialog'

interface CreateCustomMaintenanceDialog extends ShowDialogProps {
  customerId: EntityId
  localityId: EntityId
  isLocalityMaintenance?: boolean
  mainComponents?: ISimpleMainComponent[]
}

export const CreateCustomMaintenanceDialog: React.FC<CreateCustomMaintenanceDialog> = ({
  pop,
  customerId,
  localityId,
  isLocalityMaintenance = false,
  mainComponents = [],
}) => {
  const { t } = useTranslation(['maintenance', 'common'])
  const { mutateAsync, isLoading } = useAddCustomMaintenance(customerId as EntityId, localityId as EntityId)

  const onSubmit = async maintenance => {
    maintenance.id = 0
    await mutateAsync(maintenance, {
      onError: () => {
        toast.error(t('addingError', { ns: 'common' }))
      },
    })
  }

  return (
    <CreateMaintenanceForm
      pop={pop}
      addMaintenance={onSubmit}
      mainComponents={mainComponents}
      isLocalityMaintenance={isLocalityMaintenance}
      isCustomMaintenance={true}
      isLoading={isLoading}
      onSuccess={pop => {
        toast.success(t('addedSuccessfully', { ns: 'common' }))
        invalidateMaintenanceCache.invalidateAllMaintenances(customerId as EntityId, localityId as EntityId)
        invalidateScheduledMaintenanceCache.invalidateAllScheduledMaintenances(
          customerId as EntityId,
          localityId as EntityId,
        )
        invalidateLocalityCache.getMaintenanceTypesCount(customerId as EntityId, localityId as EntityId)
        pop()
      }}
    />
  )
}

export default CreateCustomMaintenanceDialog
